import type { StorefrontBranch } from "../types/storefront";
import { mockStores } from "./stores";

export const mockBranches: StorefrontBranch[] = mockStores.flatMap((store, storeIndex) => {
  const names = store.storeSlug === "freshmart" ? ["F-7 Branch", "Bahria Branch"] : ["Main Branch", "City Branch"];
  return names.map((name, index) => ({
    id: `${store.storeSlug}-branch-${index + 1}`,
    tenantSlug: store.storeSlug,
    name,
    address: index === 0 ? store.address ?? "" : `${12 + storeIndex * 5} Commercial Avenue`,
    phone: store.phone ?? "",
    isActive: true,
    deliveryEnabled: store.deliveryEnabled,
    pickupEnabled: store.pickupEnabled,
    estimatedDeliveryTime: index === 0 ? "35-50 minutes" : "45-60 minutes",
    businessHours: store.businessHours
  }));
});
